import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, accessToken) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    headers: { accesstoken: accessToken },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function getAPIUsage(accessToken) {
  const data = await fetchAPI(
    `{
      getAPIUsage {
        uid
        api_key
        start_date
        end_date
        daily_quota {
          used_quota
          remaining_quota
        }
      }
    }`, accessToken
  )
  return data
}

